import axios from '@/plugins/axios';
import { Response } from '@/types/common/Rest';
import { VUE_APP_GCN_SERVICES } from '@/constants';
import { handleApiResponse } from '@/utils/request';
import { FiltroParecer, PageParecer } from '../types';

const BASE_URL_PUBLICO = `${VUE_APP_GCN_SERVICES}/publico/parecer`;
const BASE_URL_PRIVADO = `${VUE_APP_GCN_SERVICES}/parecer`;

class ParecerService {
  public async consultarListaParecer(
    filtro: FiltroParecer
  ): Promise<Response<PageParecer>> {
    const url = `${BASE_URL_PUBLICO}/find/all`;
    return handleApiResponse(() => axios.post(url, filtro));
  }

  public async listarParecerPrivado(
    filtro: FiltroParecer
  ): Promise<Response<PageParecer>> {
    const url = `${BASE_URL_PRIVADO}/listar`;
    return handleApiResponse(() =>
      axios.get(url, {
        params: {
          dePesquisaTermos: filtro.dePesquisaTermos || undefined,
          nuProcesso: filtro.nuProcesso || undefined,
          nuParecer: filtro.nuParecer || undefined,
          nuParecerPrefixo: filtro.nuParecerPrefixo || undefined,
          anoNuParecer: filtro.anoNuParecer || undefined,
          nuParecerSufixo: filtro.nuParecerSufixo || undefined,
          dtParecerInicio: filtro.dtParecerInicio || undefined,
          dtParecerFim: filtro.dtParecerFim || undefined,
          dtDecisaoInicio: filtro.dtDecisaoInicio || undefined,
          dtDecisaoFim: filtro.dtDecisaoFim || undefined,
          flEmenta: filtro.flEmenta,
          flParecer: filtro.flParecer,
          ordenacao: filtro.ordenacao || undefined,
          numPag: filtro.numPag,
          autores: filtro.subFilter?.autores?.length ? filtro.subFilter.autores : undefined,
          categorias: filtro.subFilter?.categorias?.length ? filtro.subFilter.categorias : undefined,
          corregedores: filtro.subFilter?.corregedores?.length ? filtro.subFilter.corregedores : undefined,
          cdCategParecer: filtro.categoriaSelected?.cdCategParecer || undefined,
          autoresSelected: filtro.autoresSelected?.length
            ? filtro.autoresSelected.map((a) => a.nuFuncionario)
            : undefined,
          corregedorSelected: filtro.corregedorSelected?.length
            ? filtro.corregedorSelected.map((c) => c.nuFuncionario)
            : undefined,
        },
      })
    );
  }
}

export default new ParecerService();
